export class PlatformFilterState {
  /**
   * @var Array
   */
  selectedClusters;
}
